/**
 * localStorage for per-viewer conveniences. It can be missing or throw (private windows, blocked site
 * data, previews), so every read and write fails quietly and the page works without it.
 */
export const safeStorage = {
  getItem(key: string): string | null {
    try {
      return window.localStorage.getItem(key)
    } catch {
      return null
    }
  },
  setItem(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value)
    } catch {
      // Kept for this page view only.
    }
  }
}

/** sessionStorage, for what should last until the tab closes, failing quietly like safeStorage. */
export const safeSessionStorage = {
  getItem(key: string): string | null {
    try {
      return window.sessionStorage.getItem(key)
    } catch {
      return null
    }
  },
  setItem(key: string, value: string): void {
    try {
      window.sessionStorage.setItem(key, value)
    } catch {
      // Kept for this page view only.
    }
  }
}
